import axios from '../pages/Common/axios';
import { API_SERVER_URL } from '../pages/Common/api'

const DownloadUrl = (reportUrl, onSuccess, onError) => {
    if (reportUrl) {
        //통계 조회
        axios.get(API_SERVER_URL + reportUrl).then((response) => {

            if (response.data.status === "success") {
                // rms 경로 제거 후 파일을 blob으로 직접 다운로드 (인증 헤더 포함)
                const cleanUrl = response.data.download_url.replace(/^\/rms\//, '/');
                axios.get(cleanUrl, { 
                    responseType: 'blob',
                    headers: {
                        'Accept': 'application/pdf,application/octet-stream,*/*'
                    }
                }).then((fileResponse) => {
                    // Content-Disposition 헤더에서 파일명 추출
                    let filename = 'download.pdf';
                    const contentDisposition = fileResponse.headers['content-disposition'];
                    if (contentDisposition) {
                        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        const matches = filenameRegex.exec(contentDisposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                        }
                    }

                    // Blob URL 생성 및 다운로드
                    const blob = new Blob([fileResponse.data], { 
                        type: fileResponse.headers['content-type'] || 'application/pdf' 
                    });
                    const url = window.URL.createObjectURL(blob);
                    
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = filename;
                    link.style.display = 'none';
                    document.body.appendChild(link);

                    // 다운로드 트리거
                    link.click();
                    document.body.removeChild(link);
                    link.remove();
                    
                    // Blob URL 해제
                    window.URL.revokeObjectURL(url);
                    onSuccess();
                }).catch((fileError) => {
                    console.dir(fileError);
                    if (fileError.response && fileError.response.status === 404) {
                        onError("파일을 찾을 수 없습니다.");
                    } else if (fileError.response && (fileError.response.status === 401 || fileError.response.status === 403)) {
                        onError("파일 다운로드 권한이 없습니다.");
                    } else {
                        onError("파일 다운로드 중에 에러가 발생하였습니다.");
                    }
                });
            } else if (response.data.status === "pending") {
                setTimeout(function () {
                    DownloadUrl(reportUrl, onSuccess, onError);
                }, 10000);
            } else {
                onError("다운로드 중에 에러가 발생하였습니다3.");
            }
        }).catch((error) => {
            console.dir(error);
            onError("다운로드 중에 에러가 발생하였습니다4.");
        });
    }

}

export default DownloadUrl;